<template>
  <BaseModal
    :show="show"
    :show-close-icon="false"
    @close="close"
  >
    <div class="modal-body">
      <header class="text-center pb-4">
        <h3
          class="my-0 text-2xl font-bold"
          v-text="'You Must Pay To Proceed'"
        />
      </header>
      <section class="mx-6">
        <PaymentForm
          :run-confirm-card-setup="runPaymentSetup"
          @cardSetupConfirmed="handleCardSetupConfirmed"
          @cardSetupError="handleCardSetupError"
          @loaded="loaded = true"
        />
      </section>
      <div
        v-if="loaded"
        class="modal-footer text-center mt-8"
      >
        <button
          type="button"
          :class="{ 'load': processing }"
          :disabled="processing"
          :aria-disabled="processing"
          class="btn"
          @click="setupPayment"
          v-text="'Submit Payment'"
        />
      </div>
    </div>
  </BaseModal>
</template>

<script type="text/babel">
import { mapActions } from 'vuex'
import PaymentForm from '../MembershipFeePaymentForm'

export default {
  name: 'BlockingMembershipFeeModal',
  components: {
    PaymentForm,
  },
  data() {
    return {
      processing: false,
      runPaymentSetup: false,
      loaded: false,
      show: false,
    }
  },
  mounted() {
    if (this.$root.showBlockingMembershipFeeModal) {
      this.show = true
    }
  },
  methods: {
    ...mapActions([
      'paymentsSubmitMembershipFee',
    ]),
    close() {
      this.show = false
    },
    setupPayment() {
      this.processing = true
      this.runPaymentSetup = true
    },
    handleCardSetupConfirmed({ setupIntent }) {
      this.paymentsSubmitMembershipFee({
        setup_intent: setupIntent,
      }).then(() => {
        this.processing = false

        this.close()
      })
    },
    handleCardSetupError() {
      this.processing = false
      this.runPaymentSetup = false
    },
  },
}
</script>
